import { useQuery } from '@tanstack/react-query'
import { apiService } from '../lib/services/api'
import type {
  QueueStatus,
  WorkerStatus,
  RecentJobs,
  SystemHealth,
  SystemInfo,
  SystemMetrics,
} from '../lib/types/system'
import { SYSTEM_ENDPOINTS } from './endpoints'

export const useSystemHealth = () => {
  return useQuery({
    queryKey: ['system', 'health'],
    queryFn: async (): Promise<SystemHealth> => {
      return apiService.get(SYSTEM_ENDPOINTS.HEALTH)
    },
    refetchInterval: 30000, // Refresh every 30 seconds
  })
}

export const useSystemInfo = () => {
  return useQuery({
    queryKey: ['system', 'info'],
    queryFn: async (): Promise<SystemInfo> => {
      return apiService.get(SYSTEM_ENDPOINTS.INFO)
    },
    refetchInterval: 60000, // Refresh every minute
  })
}

export const useSystemMetrics = () => {
  return useQuery({
    queryKey: ['system', 'metrics'],
    queryFn: async (): Promise<SystemMetrics> => {
      return apiService.get(SYSTEM_ENDPOINTS.METRICS)
    },
    refetchInterval: 10000, // Refresh every 10 seconds
  })
}

export const useQueueStatus = () => {
  return useQuery({
    queryKey: ['system', 'queue-status'],
    queryFn: async (): Promise<QueueStatus> => {
      return apiService.get(SYSTEM_ENDPOINTS.QUEUES)
    },
    refetchInterval: 5000, // Refresh every 5 seconds
  })
}

export const useWorkerStatus = () => {
  return useQuery({
    queryKey: ['system', 'worker-status'],
    queryFn: async (): Promise<WorkerStatus> => {
      return apiService.get(SYSTEM_ENDPOINTS.WORKERS)
    },
    refetchInterval: 5000, // Refresh every 5 seconds
  })
}

export const useRecentJobs = (limit: number = 50) => {
  return useQuery({
    queryKey: ['system', 'recent-jobs', limit],
    queryFn: async (): Promise<RecentJobs> => {
      return apiService.get(SYSTEM_ENDPOINTS.RECENT_JOBS(limit))
    },
    refetchInterval: 10000, // Refresh every 10 seconds
  })
}
